import 'babel-polyfill'
import 'classlist-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import ViewUI from 'view-design';
import '../static/iview.css';
Vue.use(ViewUI);

// 图片预览插件
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
Vue.use(preview);

import Meta from 'vue-meta';
Vue.use(Meta)


import Header from "./components/Header";
import Footer from "./components/Footer";
Vue.component("Header", Header);
Vue.component("Footer", Footer);


import IHeader from "./components/iphone/Header";
import IFooter from "./components/iphone/Footer";
Vue.component("IHeader", IHeader);
Vue.component("IFooter", IFooter);

//打印插件
import Print from 'vue-print-nb'
Vue.use(Print); //注册


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js